export default __webpack_public_path__ + "images/km-93ef5e214ae093b8adc829329c310f7f.svg";